<ds-list-item
    [selected]="false"
    [inverse]="false"
    [boldTitle]="false"
    [showCenterSlot]="true"
    [title]="messages.RewardsCtaTitle"
    [subtitle]="balanceMessage()"
    (click)="navigateToLoyalty()">
    <span slot="start" class="rewards-cta__list-item-start">
        <vn-icon name="brp-reward-icon" size="24"></vn-icon>
    </span>
    <span slot="end" class="rewards-cta__list-item-end">
        <vn-icon name="theme-right" size="16"></vn-icon>
    </span>
</ds-list-item>
